import { render, staticRenderFns } from "./PatientRadiologyAttachments.vue?vue&type=template&id=786b20c7&scoped=true"
import script from "./PatientRadiologyAttachments.vue?vue&type=script&lang=js"
export * from "./PatientRadiologyAttachments.vue?vue&type=script&lang=js"
import style0 from "./PatientRadiologyAttachments.vue?vue&type=style&index=0&id=786b20c7&prod&lang=scss&scoped=true"
import style1 from "./PatientRadiologyAttachments.vue?vue&type=style&index=1&id=786b20c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786b20c7",
  null
  
)

export default component.exports